import { getCountrySpecifications } from "ibantools";

/**
 * Masks the bank account number based on the bank account's country and the last 4 digits.
 * @param bankAccountCountry
 * @param bankAccountLast4Digits
 * @returns Masked bank account number.
 */
export const maskBankAccountNumber = (
  bankAccountCountry: string,
  bankAccountLast4Digits: string
): string | null => {
  const countrySpecification = getCountrySpecifications()[bankAccountCountry];

  if (!countrySpecification || !countrySpecification.chars) {
    return null;
  }

  return [
    bankAccountCountry,
    bankAccountLast4Digits.padStart?.(countrySpecification.chars - 2, "*"),
  ].join("");
};

/**
 * Electronic format indicates that there are no spaces between the bank account number characters.
 * @param iban - Bank account number.
 * @returns Bank account number in electronic format.
 */
export const getBankAccountNumberInElectronicFormat = (iban: any) => {
  if (typeof iban === "string") {
    return iban.replace(/[^a-zA-Z0-9*]/g, "").toUpperCase();
  }

  return iban;
};

/**
 * Print format indicates that every 4th character is separated by a space.
 * @param iban - Bank account number.
 * @returns Bank account number in print format.
 */
export const getBankAccountNumberInPrintFormat = (iban: any) => {
  if (typeof iban === "string") {
    const electronicFormat = getBankAccountNumberInElectronicFormat(
      iban
    ) as string;
    return electronicFormat.replace(/(.{4})(?!$)/g, "$1 ");
  }

  return iban;
};
